/**
 * Shared ERP page header / hierarchy class names.
 * Visual rules live in theme-compat.css (.erp-page-*).
 */

export const erpPageHeaderClass = 'erp-page-header';
export const erpPageHeaderRowClass = 'erp-page-header-row';
export const erpPageHeaderTextClass = 'erp-page-header-text';
export const erpPageHeaderActionsClass = 'erp-page-header-actions';
export const erpPageBreadcrumbClass = 'erp-page-breadcrumb';
/** Parent crumbs — muted grey. */
export const erpPageBreadcrumbItemClass =
  'erp-page-breadcrumb-item !text-[#64748b] dark:!text-[#94a3b8]';
/**
 * Current / active crumb — same muted grey as parent (no brand blue split).
 */
export const erpPageBreadcrumbCurrentClass =
  'erp-page-breadcrumb-current !text-[#64748b] dark:!text-[#94a3b8]';
export const erpPageBreadcrumbSepClass =
  'erp-page-breadcrumb-sep !text-[#94a3b8] dark:!text-[#64748b]';
/** Exact brand accent for non-breadcrumb accents (#0088cc / dark #38bdf8). */
export const erpHeadingAccentClass =
  'erp-heading-accent !text-[#0088cc] dark:!text-[#38bdf8]';
export const erpPageTitleClass = 'erp-page-title';
export const erpPageSubtitleClass = 'erp-page-subtitle';
export const erpPageSubtitleBodyClass = 'erp-page-subtitle erp-page-subtitle--body';
export const erpPageSubtitleAccentClass = 'erp-page-subtitle-accent';
export const erpPageTabsClass = 'erp-page-tabs';
export const erpPageTabClass = 'erp-page-tab';
export const erpPageTabActiveClass = 'erp-page-tab erp-page-tab--active';

export const erpPageBtnClass = 'erp-page-btn';
export const erpPageBtnPrimaryClass = 'erp-page-btn erp-page-btn--primary';
export const erpPageBtnSecondaryClass = 'erp-page-btn erp-page-btn--secondary';

export const erpStatGridClass = 'erp-stat-grid';
export const erpStatCardClass = 'erp-stat-card';
export const erpStatCardLabelClass = 'erp-stat-card-label';
export const erpStatCardValueClass = 'erp-stat-card-value';
export const erpStatCardIconClass = 'erp-stat-card-icon';

export const erpSearchToolbarClass = 'erp-search-toolbar';
export const erpSearchToolbarFieldClass = 'erp-search-toolbar-field';
export const erpSearchToolbarInputClass = 'erp-search-toolbar-input';
export const erpSearchToolbarFiltersClass = 'erp-search-toolbar-filters';
export const erpSearchToolbarFiltersLabelClass = 'erp-search-toolbar-filters-label';
export const erpSearchToolbarSelectClass = 'erp-search-toolbar-select';

/** Compose tab button classes for page-level navigation tabs. */
export function erpPageTabClasses(active = false): string {
  return active ? erpPageTabActiveClass : erpPageTabClass;
}

/** Compose ERP stat grid columns helper (3 | 4 | 5). */
export function erpStatGridClasses(cols: 3 | 4 | 5 = 5): string {
  return `${erpStatGridClass} erp-stat-grid--${cols}`;
}
